import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/shared/lib/supabase'
import { useCurrentUser } from '@/features/auth/hooks/use-current-user'

export interface OrganizationTeam {
  id: string
  name: string
  short_id: string
}

async function fetchOrganizationTeams(organizationId: string): Promise<OrganizationTeam[]> {
  const { data, error } = await supabase
    .from('teams')
    .select('id, name, short_id')
    .eq('organization_id', organizationId)
    .order('name', { ascending: true })

  if (error) {
    throw new Error(error.message)
  }

  return (data || []) as OrganizationTeam[]
}

export function useOrganizationTeams() {
  const { user } = useCurrentUser()

  return useQuery({
    queryKey: ['organizationTeams', user?.organization_id],
    queryFn: () => fetchOrganizationTeams(user!.organization_id!),
    enabled: !!user?.organization_id,
  })
}
